export const castDateToLocaleFormat = (rawDate, locales = 'ru-RU') => {
  return rawDate ? new Date(rawDate).toLocaleDateString(locales) : null
}



// WEBPACK FOOTER //
// ./src/modules/shared/utils/date.js